module.exports = __webpack_public_path__ + "img/vouchers.7663e7d5.svg";